import { useFormContext } from "react-hook-form";
import type { FormInputProps } from "../../../uikit/Form/FormInput";
import { LocationInput } from "../../../uikit/Form/LocationInput";

export const CustomLocationInput = ({ name, ...rest }: FormInputProps) => {
  const { getValues } = useFormContext();
  const initialDisplayValue = getValues(name);

  return (
    <LocationInput
      name={name}
      initialDisplayValue={initialDisplayValue}
      {...rest}
    />
  );
};
